<script lang="ts">
  
  export let text: string = 'Back';
  export let onClick: (() => void) | null = null;
  
  function handleClick() {
    if (onClick) {
      onClick();
    }
  }
</script>

<button class="back-button" on:click={handleClick}>
  <svg class="back-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M19 12H5"></path>
    <path d="M12 19l-7-7 7-7"></path>
  </svg>
  <span class="back-text">{text}</span>
</button>

<style>
  .back-button {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0.5rem 0 1.5rem;
    padding: 0.5rem 1.25rem;
    background: #ffffff;
    border: 1px solid #d1d5db;
    color: #374151;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;
    border-radius: 25rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  .back-button:hover {
    background: #f9fafb;
    border-color: #9ca3af;
    color: #111827;
  }

  .back-button:focus-visible {
    outline: 2px solid var(--color-primary, #ffb400);
    outline-offset: 2px;
  }

  .back-arrow {
    width: 1.1rem;
    height: 1.1rem;
  }
  
  .back-text {
    line-height: 1.25rem;
  }
</style> 